<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
         
    },
    methods:{
      filter: async function(){
       let responseOrderHolder = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {typeOrder: ["CERTIFIEDS","PARTS","SERVICES"]}, `${Endpoints.orders.holder.listOrderByDate}`)).data;

        if (responseOrderHolder.status==200){

              const data = new Date();
              responseOrderHolder.date = new Date(data).toLocaleDateString();

              this.chart.data.datasets[0].data = [responseOrderHolder.results[0].nOrders];
              this.chart.data.labels = [responseOrderHolder.results[0]._id];
              this.total = responseOrderHolder.results[0].nOrders;

              for(var i = 1; i < responseOrderHolder.results.length; i++){
                  this.chart.data.labels[i] = responseOrderHolder.results[i]._id;
                  this.chart.data.datasets[0].data[i] = responseOrderHolder.results[i].nOrders;
                  this.total += responseOrderHolder.results[i].nOrders; 
                }

              this.chart.update();
        }
      }
    }
}
</script>